import React from 'react';
import styles from './LoadingSpinner.module.scss';
import { classNames } from '../../utils/helpers';
const LoadingSpinner = () => React.createElement("span", { className: classNames(styles.loading) });
export default LoadingSpinner;
